module.exports = __webpack_public_path__ + "img/c22c4693d293f670e2242a0a5a866da8.58700e09.jpg";